import React, { useEffect, useState } from "react"
import * as routes from "../../Router/RoutesURL";
import AppContainer from "../../components/AppContainer/AppContainer"
import { Tab, Tabs } from "react-bootstrap";
import Programs from "./Programs/Programs"
import Assessment from "./Assessment/Assessment"
import RecipeCollection from "./RecipeCollection/RecipeCollection"
import Activity from "./Activity/Activity"
import { Button } from "reactstrap";
import WhitePlus from "../../assets/images/CommonComponent/WhitePlus.svg"
import { useNavigate, useSearchParams } from "react-router-dom";
import { getPermissionByAppName } from "../../utils/Helper";
import "./MasterDataDashboard.scss"
import { tabKeys } from "../../Config/Constant";

const TAB_CONFIG = [
    {
      key: tabKeys.masterData.PROGRAMS,
      title: "Programs",
      permissionKey: "Program Master",
      Component: Programs,
      renderOnActive: false,
    },
    {
      key: tabKeys.masterData.ASSESSMENT,
      title: "Assessment",
      permissionKey: "Assessment Master (Section + Question)",
      Component: Assessment,
      renderOnActive: false,
    },
    {
      key: tabKeys.masterData.ACTIVITY,
      title: "Activity",
      permissionKey: "Activity Master",
      Component: Activity,
      renderOnActive: true, // render only when active
    },
    {
      key: tabKeys.masterData.RECIPE_COLLECTION,
      title: "Recipe Collection",
      permissionKey: "Recipe Master",
      Component: RecipeCollection,
      renderOnActive: false,
    },
  ];
  

const MasterDataDashboard = (props) => {
    const { history } = props;
    const [activeTab, setActiveTab] = useState("");
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const handleTabSelect = (index) => {
        if(index!==activeTab){
            const newParams = new URLSearchParams();
            newParams.set("tab", index);
            setSearchParams(newParams);
            setActiveTab(index);
        };
    }

    const handleNavigate = () => {
        if (activeTab == tabKeys.masterData.RECIPE_COLLECTION) {
            navigate(routes.ADD_RECIPE_COLLECTION, { state: { selection: "add" } })
        }
        else if (activeTab == tabKeys.masterData.ACTIVITY) {
            navigate(routes.ADD_ACTIVITY, { state: { selection: "add" } })
        }
    };

    useEffect(() => {
      const tab = searchParams.get("tab");
      if (tab) {
          setActiveTab(tab);
      } else {
          let defaultTab = tabKeys.masterData.RECIPE_COLLECTION;
          if (getPermissionByAppName("Program Master") !== "hide")
              defaultTab = "Program Master";
          else if (getPermissionByAppName("Assessment Master (Section + Question)") !== "hide")
              defaultTab = "Assessment";
          else if (getPermissionByAppName("Activity Master") !== "hide")
              defaultTab = tabKeys.masterData.ACTIVITY;
          
          setActiveTab(defaultTab);
      }
  }, [searchParams]);

    
    return (
        <AppContainer history={history}>
            <div className="event-table">
                <div className="MasterTabsContainer">
                    <div className="MasterButtonDiv">
                        {activeTab == tabKeys.masterData.RECIPE_COLLECTION && getPermissionByAppName("Recipe Master") === "write" && <Button className="btn btn-primary mt-2 addUser" type="submit" onClick={handleNavigate}>
                            <img className="mr-2 mb-1 " src={WhitePlus} alt="" width="14px" height="14px" />New Collection
                        </Button>}
                        {activeTab == tabKeys.masterData.ACTIVITY && getPermissionByAppName("Activity Master") === "write" && <Button className="btn btn-primary mt-2 addUser" type="submit" onClick={handleNavigate}>
                            <img className="mr-2 mb-1 " src={WhitePlus} alt="" width="14px" height="14px" />New Activity
                        </Button>}
                    </div>
                    <Tabs
                        id="controlled-tab-example"
                        className="TabsDiv"
                        activeKey={activeTab}
                        onSelect={handleTabSelect}
                        >
                        {TAB_CONFIG.map(
                            ({ key, title, permissionKey, Component, renderOnActive }) => {
                            const permission = getPermissionByAppName(permissionKey);

                            if (permission === "hide") return null;

                            return (
                                <Tab key={key} eventKey={key} title={title}>
                                {!renderOnActive || activeTab === key ? (
                                    <Component activeTab={activeTab} permission={permission} />
                                ) : null}
                                </Tab>
                            );
                            }
                        )}
                    </Tabs>
                </div>
            </div >
        </AppContainer >
    )
}

export default MasterDataDashboard
